export default __webpack_public_path__ + "static/media/group_image.93748fe5.svg";